"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.incorrectIdFormat = exports.formatErrorText = exports.loadingLabel = exports.newCustomerLabel = exports.existingCustomerLabel = exports.dataMismatchLabel = exports.instructionsLabel = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
// Functions
var identifications_1 = require("../../functions/identifications");
var helpers_1 = require("../../functions/helpers");
exports.instructionsLabel = (react_1.default.createElement(react_1.default.Fragment, null, "Incluye los guiones (ej. 8-888-8888), tal como aparece en tu identificaci\u00F3n."));
exports.dataMismatchLabel = (react_1.default.createElement(react_1.default.Fragment, null,
    "El ",
    react_1.default.createElement("b", null, "n\u00FAmero de identificaci\u00F3n"),
    " suministrado no coincide con la informaci\u00F3n de fecha de nacimiento y g\u00E9nero que aparece en la cotizaci\u00F3n.",
    react_1.default.createElement("br", null),
    react_1.default.createElement("br", null),
    "Por favor, verifica con tu corredor la informaci\u00F3n o solic\u00EDtale una nueva cotizaci\u00F3n."));
exports.existingCustomerLabel = (react_1.default.createElement(react_1.default.Fragment, null, "La informaci\u00F3n ha sido validada con \u00E9xito"));
exports.newCustomerLabel = (react_1.default.createElement(react_1.default.Fragment, null, "La informaci\u00F3n ha sido validada con \u00E9xito, bienvenido(a) a ASSA"));
exports.loadingLabel = react_1.default.createElement(react_1.default.Fragment, null, "Validando informaci\u00F3n...");
exports.formatErrorText = 'Su cédula no está en el formato correcto';
exports.incorrectIdFormat = (react_1.default.createElement(react_1.default.Fragment, null, "El n\u00FAmero de identificaci\u00F3n suministrado es incorrecto, por favor verifica."));
function checkGenderAndBirthday(_a) {
    var usedBirthday = _a.usedBirthday, birthday = _a.birthday, usedGender = _a.usedGender, gender = _a.gender;
    return ((usedBirthday !== '' && !helpers_1.areServerDatesEqual(usedBirthday, birthday)) ||
        (usedGender !== '' && gender !== usedGender));
}
/**
 * This is a hook used to validate customer's information agains the provided acsel data,
 * as well as managing the deferred search call.
 */
function usePersonPropertyValidator(_a) {
    var personQuery = _a.personQuery, _b = _a.usedGender, usedGender = _b === void 0 ? '' : _b, _c = _a.usedBirthday, usedBirthday = _c === void 0 ? '' : _c, identificationNumber = _a.identificationNumber, identificationType = _a.identificationType, personSearchRequestStatus = _a.personSearchRequestStatus, onPersonSearchRequested = _a.onPersonSearchRequested;
    var _d = react_1.useState(''), formatError = _d[0], updateFormatError = _d[1];
    var _e = react_1.useState(false), errorAfterEndpoint = _e[0], updateErrorAfterEndpoint = _e[1];
    var _f = react_1.useState(''), previousId = _f[0], updatePreviousId = _f[1];
    var _g = react_1.useState(false), personIsInvalid = _g[0], togglePersonIsInvalid = _g[1];
    var _h = react_1.useState(react_1.default.createElement("div", null)), messageLabel = _h[0], updateMessageLabel = _h[1];
    var _j = react_1.useState(false), idCheckRequested = _j[0], toggleIdCheckRequested = _j[1];
    // updatingId defines the lapse between the user modifying the input and before the debounce function is called
    var _k = react_1.useState(true), updatingId = _k[0], toggleUpdatingId = _k[1];
    /**
     * Maintain a reference to the debounced search method. Note that a debounced method
     * will only fire after not being invoked for a certain amount of time (in this case,
     * 1.8 seconds).
     */
    var debouncedSearchPerson = react_1.useRef(lodash_1.debounce(function (query, idType, validationError) {
        if (query.length >= 3) {
            updatePreviousId("" + query + idType);
            if (validationError) {
                togglePersonIsInvalid(true);
            }
            else {
                var formattedValue = identifications_1.formatIdentification(query, idType);
                onPersonSearchRequested(formattedValue, idType);
                toggleIdCheckRequested(true);
            }
        }
    }, 1800)).current;
    /**
     * Update the validation error
     */
    react_1.useEffect(function () {
        if (identificationType !== 'N') {
            updateFormatError('');
        }
        else {
            updateFormatError(identifications_1.isValidPersonId(identificationNumber) ? '' : exports.formatErrorText);
        }
        // reflect input updatingId status
        toggleUpdatingId(true);
    }, [identificationNumber, identificationType]);
    /**
     * Call the debounced search method each time one of these values change.
     */
    react_1.useEffect(function () {
        debouncedSearchPerson(identificationNumber, identificationType, formatError);
    }, [
        debouncedSearchPerson,
        identificationNumber,
        identificationType,
        formatError,
    ]);
    var processLabelForExistingPerson = react_1.useCallback(function () {
        if (personIsInvalid) {
            updateMessageLabel(exports.dataMismatchLabel);
        }
        else {
            updateMessageLabel(exports.existingCustomerLabel);
        }
    }, [personIsInvalid]);
    /**
     * This effect will manage the message label display logic. The logic is as follows:
     * - If a validation error occurs, display the validation error message.
     * - If the person doesn't exists, display a generic welcome.
     * - If the person exists and the data matches, display a "welcome back" message
     * - If the person exists, but the data doesn't match, display a mismatch error message.
     */
    react_1.useEffect(function () {
        if (personSearchRequestStatus === 'failure') {
            updateMessageLabel(exports.incorrectIdFormat);
            updateErrorAfterEndpoint(true);
            return;
        }
        if (personSearchRequestStatus === 'requesting') {
            updateMessageLabel(exports.loadingLabel);
        }
        else if (identificationNumber.length >= 3) {
            if (previousId !== "" + identificationNumber + identificationType) {
                return;
            }
            if (formatError) {
                updateMessageLabel(react_1.default.createElement(react_1.default.Fragment, null, formatError));
                return;
            }
            if (personQuery.exist) {
                processLabelForExistingPerson();
            }
            else {
                updateMessageLabel(exports.newCustomerLabel);
            }
        }
        else {
            updateMessageLabel(exports.instructionsLabel);
        }
        updateErrorAfterEndpoint(false);
    }, [
        identificationNumber,
        personSearchRequestStatus,
        updateMessageLabel,
        updateErrorAfterEndpoint,
        personIsInvalid,
        personQuery,
        previousId,
        identificationType,
        formatError,
    ]);
    react_1.useEffect(function () {
        // debounced function returned with success, user no longer updating
        if (personSearchRequestStatus === 'success' ||
            personSearchRequestStatus === 'failure') {
            toggleUpdatingId(false);
        }
    }, [personSearchRequestStatus]);
    /**
     * This effect will manage the personIsInvalid state.
     */
    react_1.useEffect(function () {
        if (errorAfterEndpoint) {
            togglePersonIsInvalid(true);
            return;
        }
        if (!personQuery.exist) {
            togglePersonIsInvalid(false);
            return;
        }
        var _a = personQuery.client, birthday = _a.birthday, gender = _a.gender;
        /**
         * Note that these checks are only made if the provided values are not empty
         */
        togglePersonIsInvalid(checkGenderAndBirthday({
            usedBirthday: usedBirthday,
            usedGender: usedGender,
            birthday: birthday,
            gender: gender,
        }));
    }, [
        personQuery,
        togglePersonIsInvalid,
        usedGender,
        usedBirthday,
        identificationNumber,
        identificationType,
        updatingId,
    ]);
    /**
     * We just need to expose personIsValid and messageLabel. Everything else is considered
     * "internal" implementation and should not be exposed to the rest of the application.
     */
    return {
        personIsInvalid: personIsInvalid,
        messageLabel: messageLabel,
        formatError: formatError,
        idCheckRequested: idCheckRequested,
        updatingId: updatingId,
    };
}
exports.default = usePersonPropertyValidator;
//# sourceMappingURL=usePersonPropertyValidator.js.map